import { useState } from "react";
import { toast } from "sonner";
import { Check, HeartPulse } from "lucide-react";
import { api, errMsg, fmt } from "@/lib/api";

const Session = ({ r, onChanged }) => {
  const [busy, setBusy] = useState(null);
  const tick = async (i, it) => {
    setBusy(i);
    try { onChanged((await api.post(`/client/me/recovery/${r.sessionId}/tick`, { index: i, done: !it.doneAt })).data); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  const full = r.total > 0 && r.done === r.total;
  return (
    <div className={`panel recovery ${full ? "fullweek" : ""}`} data-testid={`recovery-card-${r.sessionId}`}>
      <div className="ph">
        <h3><HeartPulse size={14} style={{ verticalAlign: -2, marginRight: 6 }} />{r.plan} · {fmt(r.startAt, { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" })}</h3>
        <span className="ss num" data-testid={`recovery-progress-${r.sessionId}`}>{r.done}/{r.total} done</span>
      </div>
      {r.description && <p className="ss" style={{ marginTop: 0 }}>{r.description}</p>}
      <div className="rbar" style={{ marginBottom: 10 }}><i style={{ width: `${r.total ? Math.round((r.done / r.total) * 100) : 0}%` }} /></div>
      {full && <div className="fw" data-testid={`recovery-complete-${r.sessionId}`}><Check size={14} /> <b>Recovery day done.</b> Counts toward this week's ticks.</div>}
      <table className="tbl" data-testid={`recovery-table-${r.sessionId}`}><tbody>{r.items.map((it, i) => (
        <tr key={i} data-testid={`recovery-item-${i}`} style={{ opacity: it.doneAt ? .55 : 1 }}>
          <td style={{ width: 36 }}><button className={`tick ${it.doneAt ? "on" : ""}`} disabled={busy === i} onClick={() => tick(i, it)} aria-label={it.doneAt ? "Mark not done" : "Mark done"} data-testid={`recovery-tick-${i}`}>{it.doneAt && <Check size={13} />}</button></td>
          <td><b style={{ textDecoration: it.doneAt ? "line-through" : "none" }}>{it.name}</b></td>
          <td className="num ss">{it.prescription || ""}</td>
        </tr>))}</tbody></table>
    </div>
  );
};

export const RecoveryCards = ({ items, onChanged }) => (items || []).map((r) => <Session key={r.sessionId} r={r} onChanged={onChanged} />);
